import { render, staticRenderFns } from "./ComNull.vue?vue&type=template&id=559ceaa0&scoped=true"
import script from "./ComNull.vue?vue&type=script&lang=js"
export * from "./ComNull.vue?vue&type=script&lang=js"
import style0 from "./ComNull.vue?vue&type=style&index=0&id=559ceaa0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559ceaa0",
  null
  
)

export default component.exports